const t = "container_0iep-", n = "title_gQZ8l", o = "subtitle_eFmUB", s = "error_-6TNB", e = "countdown_GTStR", u = "resendButton_ftapT", c = "buttons_D50rP", r = "secondaryButton_bf1aH", i = "submitButton_jtcTR", B = {
  container: t,
  title: n,
  subtitle: o,
  error: s,
  countdown: e,
  resendButton: u,
  buttons: c,
  secondaryButton: r,
  submitButton: i
};
export {
  c as buttons,
  t as container,
  e as countdown,
  B as default,
  s as error,
  u as resendButton,
  r as secondaryButton,
  i as submitButton,
  o as subtitle,
  n as title
};
//# sourceMappingURL=phoneVerification.module.scss.js.map
